import { Component, OnInit } from '@angular/core';
import { LoginServiceService } from '../services/api/login-service.service';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.scss']
})
export class NavMenuComponent implements OnInit {

  isExpanded = false;
  role : string = '';

  constructor(private _loginService : LoginServiceService,private authService: AuthService) { }

  ngOnInit(): void {
    this.role = localStorage.getItem('Role');
  }

  collapse() {
    this.isExpanded = false;
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
  }
  logout(){

    this.authService.logout();
    this._loginService.settoggleview(false);
    localStorage.clear();
    // location.reload();
  }

}
